export default __webpack_public_path__ + "static/media/background.eda353e9.jpg";